<template>
  <v-dialog width="1150" v-model="internalDialog" persistent>
    <v-card style="overflow: hidden; padding: 0.75rem 2.5rem;">
      <v-form style="padding-bottom: 0.5rem;">
        <v-card-title class="headline" style="padding: 0.5rem;"
          >Bulk Edit</v-card-title
        >
        <v-card-actions class="form-body">
          <v-row>
            <v-col cols="12" sm="5">
              <v-select
                :items="properties"
                no-data-text="No feed types to select from"
                item-text="title"
                class="form-select"
                item-value="id"
                v-model="property"
                placeholder="Field Name"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="5" class="ml-auto">
              <v-autocomplete
                v-if="isFieldSingleSelectable || isFieldMultiSelectable"
                :key="property"
                class="form-select"
                clearable
                :items="fieldItems"
                :placeholder="fieldLabel"
                no-data-text="No feed types to select from"
                :item-text="
                  property == 'sample_condition' || property == 'is_preground'
                    ? 'text'
                    : 'title'
                "
                :item-value="
                  property == 'sample_condition' || property == 'is_preground'
                    ? 'value'
                    : 'id'
                "
                v-model="field"
                :multiple="isFieldMultiSelectable"
                :chips="isFieldMultiSelectable"
                :deletable-chips="isFieldMultiSelectable"
              ></v-autocomplete>
              <v-text-field
                v-model="description"
                v-if="isFieldTextArea"
                label="Description"
                maxlength="255"
              ></v-text-field>
              <DatePickerInput
                v-if="isFieldDatePicker"
                :date-picker-config="dateCollected"
                @updateDateField="
                  (field, val) => {
                    date_collected = val;
                  }
                "
                :clearable="true"
              ></DatePickerInput>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-vard-actions class="form-body" v-if="property == 'farm_id'">
          <v-row style="padding: 0 0.5rem;">
            <v-col cols="12" sm="5">
              <v-autocomplete
                v-if="isFieldSingleSelectable || isFieldMultiSelectable"
                :key="property"
                class="form-select"
                clearable
                :items="sources"
                item-value="id"
                item-text="title"
                placeholder="Feed Sourcs"
                no-data-text="No feed types to select from"
                v-model="farms_source_id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="5" class="ml-auto">
              <v-autocomplete
                class="form-select"
                clearable
                item-value="id"
                item-text="title"
                :items="feed_types"
                placeholder="Feed Type"
                no-data-text="No feed types to select from"
                v-model="feed_type_id"
                :disabled="!!quick_feed_type"
                @change="handleFeedTypeChange"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-vard-actions>
        <v-row class="px-4">
          <v-btn
            class="mr-auto ml-1 back-btn"
            text
            @click="internalDialog = false"
          >
            Back
          </v-btn>
          <v-btn
            :disabled="isUpdateDisabled"
            color="primary"
            class="ml-auto"
            style="text-transform: none; width: 114px;"
            @click="saveBulkSamplesEdit"
          >
            Update
          </v-btn>
        </v-row>
      </v-form>
    </v-card>
    <feed-type-reminder-dialog v-model="feedTypeReminder" @ok="handleClickOk" />
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import dayjs from "dayjs";
import { mapFields } from "vuex-map-fields";
import { mapGetters, mapState } from "vuex";
import DatePickerInput from "@/components/formElements/DatePickerInput";
import { mapActions } from "vuex/dist/vuex.common.js";
import FeedTypeReminderDialog from "./FeedTypeReminderDialog.vue";

export default {
  name: "BulkSampleEditDialog",
  props: {
    sampleIds: {
      type: String,
      default: "",
      required: true
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  components: { DatePickerInput, FeedTypeReminderDialog },
  data() {
    return {
      rules: {
        required: [rules.required]
      },
      feedTypeReminder: false,
      isFieldSingleSelectable: false,
      isFieldMultiSelectable: false,
      isFieldTextArea: false,
      isFieldDatePicker: false,
      fieldLabel: "",
      farm_id: null,
      farms_source_id: null,
      feed_type_id: null,
      description: "",
      cutting: "",
      is_preground: null,
      sample_condition: "",
      date_collected: "",
      selected_test_packages: [],
      selected_test_components: [],
      fieldItems: [],
      sampleConditionOptions: [
        { text: "Wet", value: "wet" },
        { text: "Dry", value: "dry" }
      ],
      preGroundOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false }
      ],
      cuttingOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      dateCollected: {
        label: "Sampled Date",
        field: "date_collected",
        maxDate: dayjs(new Date()).format("YYYY-MM-DD")
      },
      property: {},
      internalDialog: this.value,
      properties: [
        {
          id: "farm_id",
          title: "Farm"
        },
        {
          id: "description",
          title: "Description"
        },
        {
          id: "cutting",
          title: "Cutting"
        },
        {
          id: "is_preground",
          title: "PreGround"
        },
        {
          id: "sample_condition",
          title: "Sample Condition"
        },
        {
          id: "date_collected",
          title: "Sampled Date"
        },
        {
          id: "test_packages",
          title: "Test Packages"
        },
        {
          id: "test_components",
          title: "Test Components"
        }
      ]
    };
  },
  watch: {
    value(val) {
      this.internalDialog = val;
    },
    internalDialog(val) {
      this.$emit("input", val);
      if (!val) {
        this.property = "";
        this.clearAllFields();
      }
    },
    property(val) {
      this.clearAllFields();
      if (val == "" || !val) {
        this.fieldItems = [];
        this.fieldLabel = "";
        this.isFieldSingleSelectable = false;
        this.isFieldDatePicker = false;
        this.isFieldTextArea = false;
        return;
      }
      this.fieldItems =
        val == "farm_id"
          ? this.farms
          : (this.fieldItems =
              val == "farms_source_id"
                ? this.sources
                : (this.fieldItems =
                    val == "feed_type_id"
                      ? this.feed_types
                      : (this.fieldItems =
                          val == "cutting"
                            ? this.cuttingOptions
                            : (this.fieldItems =
                                val == "is_preground"
                                  ? this.preGroundOptions
                                  : (this.fieldItems =
                                      val == "sample_condition"
                                        ? this.sampleConditionOptions
                                        : (this.fieldItems =
                                            val == "test_packages"
                                              ? this.test_packages
                                              : (this.fieldItems =
                                                  val == "test_components"
                                                    ? this.test_components
                                                    : [])))))));
      this.isFieldSingleSelectable =
        val == "farm_id" ||
        val == "farms_source_id" ||
        val == "feed_type_id" ||
        val == "is_preground" ||
        val == "sample_condition" ||
        val == "cutting"
          ? true
          : false;
      this.isFieldMultiSelectable =
        val == "test_packages" || val == "test_components" ? true : false;
      this.isFieldTextArea = val == "description" ? true : false;
      this.isFieldDatePicker = val == "date_collected" ? true : false;
      this.fieldLabel = this.properties?.find(item => item.id == val)?.title;
    },
    farm_id(farmId) {
      if (farmId) this.getFarmSources(farmId);
    },
    farms_source_id(farmsSourceId) {
      if (!farmsSourceId) return;
      this.getFarmSource({
        farm_id: this.farmId,
        source_id: farmsSourceId
      }).then(() => {
        this.quick_feed_type = null;
        this.populateFeedFields({
          feed_class_id: this.farmSource.feed_class_id,
          id: this.farmSource.feed_type_id
        });
      });
    }
  },
  methods: {
    ...mapActions("samples", ["editBulkSamples"]),
    ...mapActions("sources", ["getFarmSource", "getFarmSources"]),
    ...mapActions(["notify"]),
    closeDialog() {
      this.internalDialog = false;
    },
    handleFeedTypeChange() {
      if (this.farms_source_id) {
        this.feedTypeReminder = true;
      }
    },
    clearAllFields() {
      this.isFieldSingleSelectable = false;
      this.isFieldMultiSelectable = false;
      this.isFieldTextArea = false;
      this.isFieldDatePicker = false;
      this.farm_id = null;
      this.farms_source_id = null;
      this.feed_type_id = null;
      this.description = "";
      this.cutting = "";
      this.is_preground = "";
      this.sample_condition = "";
      this.date_collected = "";
      this.selected_test_packages = [];
      this.selected_test_components = [];
    },
    async saveBulkSamplesEdit() {
      const result = await this.editBulkSamples({
        ids: this.sampleIds,
        ...this.editPayload
      });

      if (result.success) {
        this.notify({
          message: `${result?.message}`,
          color: "success"
        });
        this.property = "";
        this.$emit("bulkEditSaved");
      } else {
        if (result?.errors && result?.errors.length) {
          this.notify({
            message: `Failed to edit bulk samples! ${result.errors.join(", ")}`,
            color: "error"
          });
        }
        if (result?.message) {
          this.notify({
            message: `Failed to edit bulk samples! ${result.message}`,
            color: "error"
          });
        }
      }
    },
    handleClickOk() {
      this.feedTypeReminder = false;
      this.farms_source_id = null;
    },
    populateFeedFields(val) {
      if (val) {
        this.feed_class_id = val.feed_class_id;
        this.feed_type_id = val.id;
      } else {
        this.feed_class_id = null;
        this.feed_type_id = null;
      }
    }
  },
  computed: {
    ...mapGetters("farms", { farms: "getActiveItems" }),
    ...mapGetters("sources", { sources: "getActiveItems" }),
    ...mapGetters("clients", ["selectedClient"]),
    ...mapGetters("baseData", [
      "feed_types",
      "test_components",
      "test_packages"
    ]),
    ...mapFields("sampleWizard", [
      "wizard.feed_class",
      "wizard.quick_feed_type"
    ]),
    isUpdateDisabled() {
      if (
        this.property == "test_packages" ||
        this.property == "test_components"
      ) {
        return !this.field || this.field.length === 0;
      }
      if (this.property == "description") {
        return !this.description?.trim();
      }
      if (this.property == "farm_id") {
        return !this.farm_id || !this.feed_type_id;
      }
      if (this.property == "is_preground") {
        return this.field !== true && this.field !== false;
      }
      return !this.field;
    },
    editPayload() {
      if (this.property === "farm_id") {
        const payload = {
          farm_id: this.field,
          feed_type_id: this.feed_type_id
        };

        if (this.farms_source_id != null) {
          payload.farms_source_id = this.farms_source_id;
        }

        return payload;
      }

      if (this.property === "farms_source_id") {
        return { farms_source_id: this.field };
      }

      if (this.property === "feed_type_id") {
        return { feed_type_id: this.field };
      }

      if (this.property === "cutting") {
        return { cutting: this.field };
      }

      if (this.property === "is_preground") {
        return { is_preground: this.field };
      }

      if (this.property === "sample_condition") {
        return { sample_condition: this.field };
      }

      if (this.property === "test_packages") {
        return { test_packages: this.field.join(", ").trim() };
      }

      if (this.property === "test_components") {
        return { test_components: this.field.join(", ").trim() };
      }

      if (this.property === "description") {
        return { description: this.field.trim() };
      }

      if (this.property === "date_collected") {
        return { date_collected: this.field.trim() };
      }

      return null;
    },
    ...mapState("sources", { farmSource: "detailItem" }),
    field: {
      get() {
        return this.property == "farm_id"
          ? this.farm_id
          : this.property == "farms_source_id"
          ? this.farms_source_id
          : this.property == "feed_type_id"
          ? this.feed_type_id
          : this.property == "description"
          ? this.description
          : this.property == "cutting"
          ? this.cutting
          : this.property == "is_preground"
          ? this.is_preground
          : this.property == "sample_condition"
          ? this.sample_condition
          : this.property == "date_collected"
          ? this.date_collected
          : this.property == "test_packages"
          ? this.selected_test_packages
          : this.property == "test_components"
          ? this.selected_test_components
          : null;
      },
      set(value) {
        if (this.property == "farm_id") {
          this.farm_id = value;
        } else if (this.property == "farms_source_id") {
          this.farms_source_id = value;
        } else if (this.property == "feed_type_id") {
          this.feed_type_id = value;
        } else if (this.property == "description") {
          this.description = value;
        } else if (this.property == "cutting") {
          this.cutting = value;
        } else if (this.property == "is_preground") {
          this.is_preground = value;
        } else if (this.property == "sample_condition") {
          this.sample_condition = value;
        } else if (this.property == "date_collected") {
          this.date_collected = value;
        } else if (this.property == "test_packages") {
          this.selected_test_packages = value;
        } else if (this.property == "test_components") {
          this.selected_test_components = value;
        }
      },
      isFieldSingleSelectable: {
        get() {
          return (
            this.property == "farm_id" ||
            this.property == "farms_source_id" ||
            this.property == "feed_type_id" ||
            this.property == "cutting" ||
            this.property == "is_preground" ||
            this.property == "sample_condition"
          );
        }
      },
      isFieldMultiSelectable: {
        get() {
          return (
            this.property == "test_packages" ||
            this.property == "test_components"
          );
        }
      }
    }
  }
};
</script>
<style>
.form-body .v-select__slot {
  border: 1px solid rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  padding-left: 12px;
  min-height: 40px;
}

.back-btn {
  border: 1px solid #000;
}

.form-select.v-text-field > .v-input__control > .v-input__slot::before {
  display: none;
}

.v-chip .v-chip__content {
  text-wrap: auto;
}

.v-chip.v-size--default {
  min-height: 32px;
}
</style>
